<template>
  <main class="website-main">
    <div class="gradient-top">
      <v-section-intro />
      <v-section-about-me />
    </div>
    <v-section-portfolio />
    <div class="gradient-bottom">
      <v-card-reference />
      <v-section-articles />
      <v-section-external-calculators />
      <v-section-contact-form />
    </div>
  </main>
</template>

<script setup>
import { onMounted, defineProps } from 'vue'
import { useMicrositeStore } from '../stores/useMicrositeStore'
import VCardReference from '../components/v-card/VCardReference.vue'
import VSectionAboutMe from '../components/v-section/VSectionAboutMe.vue'
import { useArticleStore } from '../stores/useArticleStore'
import VSectionArticles from '../components/v-section/VSectionArticles.vue'
import VSectionIntro from '../components/v-section/VSectionIntro.vue'
import VSectionPortfolio from '../components/v-section/VSectionPortfolio.vue'
import VSectionContactForm from '../components/v-section/VSectionContactForm.vue'
import VSectionExternalCalculators from '../components/v-section/VSectionExternalCalculators.vue'

const props = defineProps({
  microsite: {
    type: Object,
    required: true
  },
  blog: {
    type: Object,
    required: true
  }
})

const micrositeStore = useMicrositeStore()
const articleStore = useArticleStore()

onMounted(() => {
  micrositeStore.setMicrosite(props.microsite)
  articleStore.setArticles(props.blog)
})
</script>
